import React from 'react'
import BkgImg from 'gatsby-background-image'
import { Waypoint } from 'react-waypoint'
import Swiper from 'react-id-swiper'
import Sticker from 'react-stickyfill'

import 'swiper/css/swiper.css'
import './scrollGallery.scss'

class Gallery extends React.Component {
  constructor(props) {
    super(props)
    this.handleWaypointEnter = this.handleWaypointEnter.bind(this)
  }

  handleWaypointEnter(i) {
    if (this.state.swiper) {
      this.state.swiper.slideTo(i)
    }
  }

  render() {
    const { block, changeHeaderVisibility } = this.props

    const params = {
      speed: 600,
      slidesPerView: 1,
      spaceBetween: -1,
      effect: 'fade',
    }

    return (
      <Waypoint
        bottomOffset="50%"
        onEnter={() => {
          changeHeaderVisibility(false)
        }}
        onLeave={e => {
          if (
            e.currentPosition === 'above' &&
            block.customClass === 'keep-header-hidden-above'
          ) {
            return
          }
          changeHeaderVisibility(true)
        }}
      >
        <section
          className={`scroll-gallery clearfix ${
            block.customClass ? block.customClass : ''
          }`}
        >
          <Sticker>
            <Swiper
              {...params}
              getSwiper={swiper => {
                this.setState({ swiper })
              }}
            >
              {block.entry.map((entry, i) => {
                // console.log(entry)
                return (
                  <div key={`gallery-${block.id}-image-${i}`}>
                    <BkgImg
                      className="bkg"
                      fluid={entry.image.childImageSharp.fluid}
                    />
                  </div>
                )
              })}
            </Swiper>
          </Sticker>
          {block.entry.map((entry, i) => {
            // console.log(entry)
            return (
              <div className="step" key={`gallery-${block.id}-step-${i}`}>
                <p>{entry.legend}</p>
                <Waypoint
                  onEnter={() => {
                    this.handleWaypointEnter(i)
                  }}
                />
              </div>
            )
          })}
        </section>
      </Waypoint>
    )
  }
}

export default Gallery
